import {
  BlindsClosedOutlined,
  DoorFrontOutlined,
  ElevatorOutlined,
  EnergySavingsLeafOutlined,
  MapsHomeWorkOutlined,
  SolarPowerOutlined,
} from "@mui/icons-material";
import {
  LinkConceptProps,
  ModalConceptProps,
} from "components/inputs/SubConceptButton";
import {
  CREATE_BLOCKS,
  CREATE_ENVIRONMENT,
  CREATE_PHOTOVOLTAIC,
  EDIT_INSTALATION,
  GREEN_ENERGY_CONTRACT,
} from "routers/routePaths";

export const BUILDING_STRUCTURES: Array<
  LinkConceptProps | Omit<ModalConceptProps, "onClick">
> = [
  {
    label: "Informações gerais",
    Icon: MapsHomeWorkOutlined,
    action: "click",
  },
  {
    label: "Instalações",
    Icon: BlindsClosedOutlined,
    linkTo: EDIT_INSTALATION,
    action: "link",
  },
  {
    action: "link",
    label: "Blocos e pavimentos",
    Icon: ElevatorOutlined,
    linkTo: CREATE_BLOCKS,
  },
  {
    action: "link",
    label: "Contratos de energia verde",
    Icon: EnergySavingsLeafOutlined,
    linkTo: GREEN_ENERGY_CONTRACT,
  },
  {
    action: "link",
    label: "Energia Solar",
    Icon: SolarPowerOutlined,
    linkTo: CREATE_PHOTOVOLTAIC,
  },
  {
    action: "link",
    label: "Ambientes",
    Icon: DoorFrontOutlined,
    linkTo: CREATE_ENVIRONMENT,
  },
];
